import appConfig from '../config/appConfig';
import { AddressType } from '../core/apiTypes';
import { stringsRes } from '../resources/strings';

// Navigation Bars
export const NavTopBarHeight = 52;
export const NavSideBarWidth = 260;

// Axios
export const AXIOS_TIMEOUT = 45 * 1000;

// Renewed Token
export const REFRESH_TOKEN_MIN_INTERVAL = 5000; // 5 secondes en ms

// Basic config
export const TIMEZONE_FROM_SERVER = 'Europe/Paris';
export const REFRESH_TIME = 30 * 1000;
export const REFRESH_TIME_SOON = 10 * 1000 * (appConfig.isDev ? 5 : 1);
export const TRACKING_PULL_TIME = 10 * 1000; // 10s
export const DRIVER_PULL_TIME = 10 * 1000; // 10s
export const DELAY_SET_NO_DRIVER_AVAIALBLE = 6000;

// Quote
export const REFRESH_QUOTE = 20 * 1000; // 20s

// React-query
export const RETRY_QUERY = appConfig.isDev ? 0 : 2;
export const RETRY_MUTATION = appConfig.isDev ? 0 : 2;
export const DEFAULT_STALE_TIME = 5000;
export const DISCARDED_TIME = 1000;
export const DISCARDED_CODE = 430;

// FAQ
export const STALETIME_FAQ = 60 * 60 * 12; // 12h
export const MAX_FILE_SIZE_FAQ = 10 * 1000 * 1000; // 10 MB
export const TARGET_FILE_SIZE = 1 * 1000 * 1000; // 1 MB
export const TARGET_FILE_WIDTH = 1280;
export const TARGET_FILE_HEIGHT = 720;

// AutoComplete
export const MIN_CHAR_AUTOCOMPLETE = 3; // Fetch only when we reach the min char
export const INTERVAL_CHAR_AUTOCOMPLETE = 3; // Refetch every x chars
export const DEBOUNCE_TIME_AUTOCOMPLETE = 300; // Debounce time in ms
export const STALETIME_AUTOCOMPLETE = 60 * 60 * 1000; // Time before new refrech

// Schedule time
export const MIN_DELAY = 35;
export const MIN_RESERVATION = 30;
export const MIN_DELAY_PLANE = 45;

// Phone checks
export const MIN_PHONE_ERROR = 5;
export const MIN_PHONE_FR_LENGTH = 10;

// Booking Ride Reason
export const MIN_CHAR_RIDE_REASON = 3;

// Status Driver
export const DRIVER_ETA_TIME = 7;

// Self Service
export const DISABLE_TIME = 5 * 1000;

// Filter
export const MAX_FILTER_LABEL = 29;

// Recent
export const MAX_RECENT_ADDRESSES = 20;
export const MAX_RECENT_PASSENGERS = 20;

// Return Trip
export const RETURN_TRIP_HOURS_DELAY = 4;

// MAD
export const MAX_MAD_TIME = 12;
export const MAD_DEFAULT_VALUE = '60';
export const FREE_RIDE = '0';

// POI
export const POI_SHORT_LIST_LENGTH = 3;

// Policy
export const POLICY_KEY = [
    'restrictions',
    'cost_centers',
    'cost_center_mandatory',
    'allowed_rides_types',
    'disabled_dispatch_groups',
    'tip_not_allowed',
    'travel_reason_mandatory',
    'book_for_group_members',
    'book_for_group_guests',
    'no_default_cost_center',
    'default_cost_center_mode',
    'default_pickup_mode',
    'default_dropoff_mode',
    'favorites',
    'restrictions.areas',
    // 'max_group_members', // Not used for the moment
    'default_settings.default_addresses.pickup',
    'default_settings.default_addresses.dropoff',
    'default_settings.default_dispatch_group_id',
];

// Recurrence
export const DAYS = [
    { key: 1, value: stringsRes.time.mon },
    { key: 2, value: stringsRes.time.tue },
    { key: 3, value: stringsRes.time.wed },
    { key: 4, value: stringsRes.time.thu },
    { key: 5, value: stringsRes.time.fri },
    { key: 6, value: stringsRes.time.sat },
    { key: 0, value: stringsRes.time.sun },
    { key: 8, value: stringsRes.time.weekend },
    { key: 7, value: stringsRes.time.week },
    { key: 9, value: stringsRes.time.allDays },
];

export const SHORT_DAY_LENGTH = 2;

// APP STORE URLS
export const APP_IOS_URL = 'https://apps.apple.com/fr/app/lecab-vtc-chauffeur-priv%C3%A9/id898160912';
export const APP_ANDROID_URL = 'https://play.google.com/store/apps/details?id=fr.lecab.android';

// INTERNAL URLS
export const WEBSITE_GREEN_URL = 'https://lecab.fr/vtc-gammes-green-mobilite-durable';
export const WEBSITE_CGV_URL = 'https://lecab.fr/conditions-generales-de-vente/';
export const WEBSITE_MENTIONS_URL = 'https://lecab.fr/mentions-legales/';
export const WEBSITE_CONFIDENTIAL_URL = 'https://lecab.fr/politique-de-confidentialite/';
export const WEBSITE_SELF_SERVICE_URL = 'https://news.lecab.fr/ouverture-de-compte-lecab-pro';

// MOBILE
export const IOS_BOTTOM_BAR_HEIGHT = 40;
export const DEFAULT_TOP_BAR_HEIGHT = 88;
export const REFRESH_LOCATION_THRESHOLD = 0.5; // 0.5 km

// RATING / TIPS
export const DEFAULT_TIPS_ARRAY = [1, 2, 5, 10];
export const MIN_NO_COMMENT = 5; // minimum of stars to not show comments and tags
export const MAX_RATING_TAGS = 3;
export const MIN_RATING_FOR_TIPS = 4; // 4 and 5 stars to tip
export const MAX_TIP_AMOUNT = 100;

// DIDOMI
export const RGPD_VENDORS_ID = [
    'google',
    'c:hubspot',
    'c:sentry',
    'c:googleana-4TXnJigR',
    'c:lecab-Wixq7CLz',
    'c:awscaptch-xQFY9xq8',
];
export const RGPD_VENDOR_ID_GA = RGPD_VENDORS_ID.find((v) => v.includes('c:googleana'));
export const RGPD_VENDOR_ID_SENTRY = RGPD_VENDORS_ID.find((v) => v.includes('c:sentry'));

// TOAST
export const TOAST_DEDUPE_TIMEOUT = 5000; // Timeout before showing the same toast again (in milliseconds)

// FAMILY
export const MAX_FAMILY_MEMBERS = 4; // Maximum number of family members allowed

// FAVORITES
export const MAX_FAVORITES = 20; // Maximum number of favorite addresses allowed
export const FAVORITES_ORDER = [AddressType.HOME, AddressType.WORK, AddressType.FAVORITE];

// USERS
export const MAX_USERS_FULLNAME_LENGTH = 30;
export const MAX_USERS_NAMES = 40; // firstname/lastname/nickname max length

// MAP
export const MAP_DEFAULT_ZOOM = 13;
export const MAP_DEFAULT_CENTER = { lat: 48.864716, lng: 2.349014 }; // Paris center
export const MAP_MAX_ZOOM = 20;
export const MAP_MAX_ZOOM_FIT_BOUNDS = 17;
